import '../../../../models/customer/ticket_summary_collection.js.coffee';# Added by Script 

Customer.Dashboard ||= {}

class Customer.Dashboard.AssignmentView extends Backbone.View
  template: JST["backbone/templates/customer/ticket/header/assignment"]
  events:
    'change #assigned_to': 'onAssignHandler'
    'click #assign-to-me': 'onAssignToMe'

  initialize: (usersGroups, model, users) ->
    @model = model
    @users = users
    @nobody = @_getEmptyUser(users)
    @usersGroups = @_getUserGroups(usersGroups)
    @selectedOption = {attributes: {}}

  render: =>
    @$el.html(@template(
      model: @model.asJson(),
      users_groups: @usersGroups,
      nobody: @nobody,
      current_user: Keepcon.current_user,
      current_user_is_assignable: @currentUserIsAssignable(),
      assigned_operator_id : @assignedToOperatorId(),
      chatbot_code : @chatbotCode(),
      assigned_to_robot : @assignedToRobot(),
      assigned_user: @assignedName(),
      assigned_id: @assignedId(),
      blank_default: @_leaveDefaultBlank()
    ))
    @$el.find('#assigned_to').chosen(width: '190px', include_group_label_in_selected: true)
    @

  onAssignHandler: (event) =>
    $selectedOption = $(event.currentTarget).find(':selected')
    @onAssign($selectedOption)

  onAssign: (selectedOption) =>
    @_keepCustomerSessionAlive()
    userId = selectedOption.data('userId')
    groupId = selectedOption.data('groupId')
    selectedOptionText = selectedOption[0].text
    attributes = assigned_to_id: userId, users_group_id: groupId
    @selectedOption = {
      userId: userId
      groupId: groupId
      assignedToName: selectedOptionText
      assignedToGroupName: selectedOption.closest('optgroup').attr('label')
      attributes: attributes
    } # this is needed for external use
    reRender = false
    @trigger('assignmentChange', userId, groupId, selectedOptionText, reRender)
    @trigger('assignmentView:changed', selectedOptionText != null)

  onAssignToMe: (event) ->
    selectedOptionText = Keepcon.current_user.first_name + ' ' + Keepcon.current_user.last_name
    @insertUserOption(Keepcon.current_user)
    $('#assigned_to').val(Keepcon.current_user.id)
    $('#assigned_to').trigger("chosen:updated")
    selectedOption = $('#assigned_to').find(':selected')
    @onAssign(selectedOption)

  insertUserOption: (user) ->
    users = @$el.find('#assigned_to').children('option').map( (i, e) =>
      return e.value || e.innerText
    ).get()
    unless _.contains(users, String(user.id))
      $('#assigned_to').append(
          "<option data-group-id='' data-user-id='" + user.id + "' value='" + user.id + "'>" + user.first_name + ' ' + user.last_name + "</option>"
      )

  currentUserIsAssignable: ->
    this.notAlreadyAssignedToCurrentUser() && _.some(@usersGroups, (group) =>
      _.some(group[1], (user) =>
        user.id == Keepcon.current_user.id
      )
    )

  notAlreadyAssignedToCurrentUser: ->
    return Keepcon.current_user.id != this.assignedId()

  _getUserGroups: (usersGroups) ->
    [group, @_getUsersIn(group)] for group in usersGroups when group.show_in_customer

  _getUsersIn: (group) ->
    user for user in @users when _.contains(group.user_ids, user.id)

  _getEmptyUser: (users) ->
    _.find(users, (u) -> u.first_name == 'Nobody')

  _leaveDefaultBlank: ->
    # Dropdown default should be left blank in filter view, but not in ticket view
    @model instanceof Customer.TicketSummaryCollection

  assignedName: ->
    @model.attributes && @model.attributes.assigned_to_name

  assignedId: ->
    @model.attributes && @model.attributes.assigned_to_id

  assignedToOperatorId:->
    @model.attributes && @model.attributes.assigned_operator_id

  chatbotCode:->
    @model.attributes && @model.attributes.chatbot_code

  assignedToRobot:->
    @model.attributes && @model.attributes.assigned_to_robot

  _keepCustomerSessionAlive:->
    Backbone.trigger 'customerSession:keepAlive'
